import cc from "@superblocksteam/iso-currency";

export const CurrencyList = cc.getCodes();
